import React from 'react'

function DatoTopNav({item,dato,datoBox,dataRow }) {
  return (
    <div className={`${datoBox} flex flex-row items-center`}>
          <label className={`${dataRow} text-2xs xl:text-sm`}>{item }</label>
          <label className={`${dataRow} mx-1 text-2xs xl:text-sm`}>{ dato}</label>
  </div>
  )
}

export default DatoTopNav